import React from 'react'
import { observer } from 'mobx-react'
import DateInput from '../input/date'
import EmbededEntityInput from '../input/batch_update_embedded_entity'
import moment from 'moment'

const FPrivateHomepageUpdateEdit = ({ store, label, items, disabledEntityFromBatch, ...rest }) => {
  const _FPrivateHomepageUpdateForm = observer(({ record, state, updateFormField, errors }) => {
    const dateRestriction = store.timeRestriction.flyprivate_homepage_settings
    const alowedJustValidTo = store.cv.items
      .some(i => moment(i.valid_from)
        .isBefore(moment(dateRestriction.valid_from.restriction)))

    let validToMindate = alowedJustValidTo
      ? dateRestriction.valid_to.minDate
      : dateRestriction.valid_to.minDateToday
    validToMindate = moment(record.get('valid_from')).isBefore(moment(validToMindate))
      ? record.get('valid_from')
      : validToMindate

    return (
      <div className='row'>
        <div className='col-sm-12 col-md-6'>
          <DateInput
            label={store.__('valid to')} attr={'valid_to'}
            record={record} onChange={updateFormField} errors={errors}
            minDate={validToMindate}
          />
        </div>
      </div>
    )
  })

  return (
    <EmbededEntityInput
      attr='flyprivate_homepage_settings_update'
      disabled={!!disabledEntityFromBatch}
      label={label}
      store={store}
      EditForm={_FPrivateHomepageUpdateForm}
      {...rest}
    />
  )
}

export default FPrivateHomepageUpdateEdit
